export default __webpack_public_path__ + "static/icon-34-1-cbc50ad962a179757249e045e05ca109.png";